<template>
  <appointment-complete
    :complete-appointment="completeAppointment"
    :get-appointment-info="getAppointmentInfo"
    :get-appointment-locations="getAppointmentLocations"
    :get-appointment-municipalities="getMunicipalities"
    :get-appointment-therpies="getAppointmentTherpies"
    :get-frequency-type="getFrequencyType"
    :get-reasons-apointment-status="getReasonsApointmentStatus"
    :get-reevaluation-times="getReevaluationTimes"
    :get-service-modalities="getServiceModalities"
    :get-services="getTherapyServices"
    :get-specialist-by-location="getSpecialistByLocation"
    :get-specialist-practitioners="getSpecialistPractitioners"
    :get-therapy-durations="getTherapyDurations"
    :input-options="getInputOptions"
  />
</template>

<script>
import { AppointmentComplete } from 'appointment-management';
import {
  getAppointmentInfo as _getAppointmentInfo,
  getSpecialistPractitioners as _getSpecialistPractitioners,
  getAppointmentLocations as _getAppointmentLocations,
  getSpecialistByLocation as _getSpecialistByLocation,
  completeAppointment as _completeAppointment,
  saveStudentEvaluationDocumentRelationship,

  //recomendation intervention services
  getAppointmentTherpies as _getAppointmentTherpies,
  getTherapyServices as _getTherapyServices,
  getReasonsApointmentStatus as _getReasonsApointmentStatus,
} from '@/modules/provider/api';

//recomendation intervention services
import {
  getFrequencyType as _getFrequencyType,
  getServiceModalities as _getServiceModalities,
  getTherapyDurations as _getTherapyDurations,
  getReevaluationTimes as _getReevaluationTimes,
} from '@/modules/shared/code.api.js';

import { getMunicipalities as _getMunicipalities } from '@/modules/shared/providerappointment.api';

export default {
  name: 'AppointmentCompleteWrapper',
  components: {
    AppointmentComplete,
  },
  computed: {
    getInputOptions() {
      return {
        diagnosticImpression: {
          maxlength: 2000,
        },
      };
    },
  },
  methods: {
    getAppointmentInfo(id) {
      return _getAppointmentInfo(id);
    },
    getSpecialistPractitioners(disciplineTypeCod, specialistLocationId) {
      return _getSpecialistPractitioners(
        disciplineTypeCod,
        specialistLocationId
      );
    },
    getMunicipalities(_, companyId) {
      return _getMunicipalities(companyId);
    },
    getAppointmentLocations(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationAddressMunicipalityId
    ) {
      return _getAppointmentLocations(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationAddressMunicipalityId
      );
    },
    getSpecialistByLocation(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationFiscalYearId
    ) {
      return _getSpecialistByLocation(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationFiscalYearId
      );
    },
    async completeAppointment(params) {
      const { data: response } = await _completeAppointment(params);
      return await saveStudentEvaluationDocumentRelationship(response);
    },

    //intervention recomendation service handlers
    getAppointmentTherpies(id) {
      return _getAppointmentTherpies(id);
    },
    getTherapyServices(serviceTypeIds, categories) {
      return _getTherapyServices(serviceTypeIds, categories);
    },
    getFrequencyType() {
      return _getFrequencyType();
    },
    getServiceModalities(disciplineTypeId) {
      let payload = {
        Screen: 'AppointmentComplete',
        DisciplineTypeId: null,
      };

      if (disciplineTypeId !== undefined && disciplineTypeId > 0) {
        payload.DisciplineTypeId = disciplineTypeId;
      }

      return _getServiceModalities(payload);
    },
    getTherapyDurations() {
      return _getTherapyDurations();
    },
    getReasonsApointmentStatus(filter) {
      return _getReasonsApointmentStatus(filter);
    },
    getReevaluationTimes() {
      return _getReevaluationTimes();
    },
  },
};
</script>
